var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAssessmentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.25006C8.76456 6.25103 8.11698 6.26672 7.61502 6.52248C7.14462 6.76217 6.76217 7.14462 6.52248 7.61502C6.25 8.1498 6.25 8.84987 6.25 10.25V22.25C6.25 23.6501 6.25 24.3502 6.52248 24.885C6.76217 25.3554 7.14462 25.7378 7.61502 25.9775C8.1498 26.25 8.84987 26.25 10.25 26.25H19.75C21.1501 26.25 21.8502 26.25 22.385 25.9775C22.8554 25.7378 23.2378 25.3554 23.4775 24.885C23.75 24.3502 23.75 23.6501 23.75 22.25V10.25C23.75 8.84987 23.75 8.1498 23.4775 7.61502C23.2378 7.14462 22.8554 6.76217 22.385 6.52248C21.883 6.26672 21.2354 6.25103 20 6.25006M10 6.25006V8.75H20V6.25006M10 6.25006V5.88388C10 5.31794 10.2248 4.77518 10.625 4.375C11.0252 3.97482 11.5679 3.75 12.1339 3.75H17.8661C18.4321 3.75 18.9748 3.97482 19.375 4.375C19.7752 4.77518 20 5.31794 20 5.88388V6.25006M20 13.75H17.5M20 20H17.5M10 13.75L11.25 15L13.75 12.5M10 20L11.25 21.25L13.75 18.75",
    stroke: "#FFFCF8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssessmentIcon);
export default __webpack_public_path__ + "static/media/assessment_icon.d92701018b64393017255656d436a640.svg";
export { ForwardRef as ReactComponent };